import { format } from "date-fns";

import { Item } from "../components/Generic/History";
import { History } from "../models/history";
import { User } from "../models/user";

export default function getItemsToHistory(
  currentUser: User,
  jobId?: number,
  histories?: History[]
) {
  const { name, lastName } = currentUser;

  if (!jobId) {
    return [
      {
        title: "Creating a quote",
        activityDate: `${format(new Date(), "dd/MM/yyyy hh:mmaaa")}`,
        activityUser: `${name ?? ""} ${lastName ?? ""}`,
        activityUserIp: "",
      } as Item,
    ];
  }

  if (histories && histories.length > 0) {
    const historiesArr = [...histories] || [];

    return historiesArr.map((history) => {
      const user = history.user
        ? `${history?.user?.name ?? ""} ${history?.user?.lastName ?? ""}`
        : "";

      const customer = history?.customer ? `${history?.customer?.fullName ?? ""}` : "";

      const from = history.fromIntegration ? "Integration" : user || customer;

      return {
        title: history?.action,
        activityDate: history?.updatedAt
          ? `${format(new Date(history?.updatedAt), "dd/MM/yyyy hh:mmaaa")}`
          : "",
        activityUser: from,
        activityUserIp: history.userIpAddress ?? "",
      } as Item;
    });
  }
}
